<template>
	<div class="c-controls c-controls" v-if="subject">
		<div class="c-controls__group">
			<label class="c-controls__label">Antwoord ingestuurd</label>
			<ul class="c-team-status">
				<li
					class="c-team-status__item"
					v-for="team in teams"
					:key="team.uuid"
					:class="{
						'team-finished': teamHasAnswer(team),
					}"
				>
					{{ team.name }}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import BaseControl from './BaseControl';

export default {
	name: 'TeamStatusControl',
	mixins: [BaseControl],
	props: {
		subject: '',
		type: '',
	},
	computed: {
		teams() {
			return this.$actions.getTeams();
		},
	},
	methods: {
		teamHasAnswer(team) {
			const settings = team.settings || {};
			const answers = settings[this.type] || {};
			return !!answers[this.subject];
		},
	},
};
</script>

<style scoped>
/* li {
	color: red;
}

.team-finished {
	color: green;
} */
</style>
